import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { SearchIcon } from '../common/mdPageIcons';

function UserPlusIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M19 8v6M22 11h-6" />
    </svg>
  );
}

export class MDAlumnoxCarrera extends Component {
  static displayName = MDAlumnoxCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.searchInputRef = React.createRef();
  }

  handleRemoveItem = (item) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: item.alumnoxCarreraCod,
        dni: item.alumnoDni,
        nombre: item.alumnoNombre,
        carrera: item.carreraNombre,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWAlumnosxCarrera');
    if (canAccess) {
      this.populateData();
    }
  }

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  renderTable(items) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="md-axc-title">
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text">DNI</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Nombre y Apellido</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Carrera</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.alumnoxCarreraCod}>
                <MdTableCell cellType="text">{item.alumnoDni}</MdTableCell>
                <MdTableCell cellType="text">{item.alumnoNombre}</MdTableCell>
                <MdTableCell cellType="text">{item.carreraNombre}</MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions
                    items={buildStandardRowActions({
                      editTo: '/update-axc/' + item.alumnoxCarreraCod + '/0',
                      onDelete: () => this.handleRemoveItem(item),
                      deleteDisabled: this.state.loading || this.state.deletingId === item.alumnoxCarreraCod,
                      deleteLabel: this.state.deletingId === item.alumnoxCarreraCod ? 'Eliminando...' : 'Borrar',
                      detailTo: '/update-axc/' + item.alumnoxCarreraCod + '/1',
                    })}
                  />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-axc">
        <h1 id="md-axc-title" className="md-page__title">Manejar Datos de Alumnos por Carrera</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <>
          <div className="md-page__toolbar">
            <Link className="md-page__action-link" to="/add-axc">
              <UserPlusIcon />
              Inscribir alumno
            </Link>
          </div>

          <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
            <div className="md-page__search-wrap">
              <span className="md-page__search-icon">
                <SearchIcon />
              </span>
              <input
                ref={this.searchInputRef}
                className="md-page__search-input"
                type="text"
                name="search"
                autoComplete="off"
                disabled={isBusy}
                placeholder="Ingrese DNI o apellido del alumno"
                value={this.state.searchInput}
                onChange={this.handleSearchInputChange}
              />
            </div>
            <button type="submit" className="md-page__search-btn" disabled={isBusy}>
              Buscar
            </button>
          </form>

          {contents}

          {!listLoading && this.state.pageCount > 0 ? (
            <div className="md-page__pagination">
              <ReactPaginate
                previousLabel="Anterior"
                nextLabel="Siguiente"
                breakLabel="..."
                breakClassName="break-me"
                pageCount={this.state.pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                forcePage={Math.floor(this.state.offset / this.state.perPage)}
                onPageChange={this.handlePageClick}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
              />
            </div>
          ) : null}
        </>

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar alumno por carrera"
          message="Esta acción eliminará la inscripción del alumno en la carrera y no se puede deshacer."
          detail={
            pendingDelete
              ? `${pendingDelete.nombre} — DNI ${pendingDelete.dni} — ${pendingDelete.carrera}`
              : ''
          }
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/axc/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/axc/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data) || data.returnModel === false) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar el registro. Verifique si tiene datos asociados e intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({
        successMessage: 'El registro se eliminó correctamente.',
        pendingDelete: null,
      });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }
}
